<div class="flex flex-col ml-72 mr-72 mt-8 component-container">
	<app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
    <div class="flex flex-row justify-between mb-24">
		<div class="flex flex-row flex-auto header-section p-24 mt--20">
		  <div class="flex flex-row items-center pr-24">
			<mat-icon svgIcon="arrow_back" class="cursor-pointer icon-lg" (click)="goToTenant()"></mat-icon>
		  </div>
		  <div class="flex flex-col flex-auto justify-between pr-20">
			<div class="flex flex-row justify-between mb-12">
			  <div class="mat-subtitle-1 fw-600 fs-24 mb-0">{{'INSTANCE_DETAILS.COMPONENT_UPDATE' | transloco}}</div>
			</div>
			<div class="flex justify-between">
			  <div class="flex flex-row sub-header items-center">
				<div *ngIf="blueprintData?.name; else loader" class="pr-12 flex vertical-indicator items-center">{{'INSTANCE_DETAILS.SERVICE_DEFINITION' | transloco}}: <span class="fw-600 fs-14 pl-6">{{blueprintData.name}}</span></div>
        <div *ngIf="data?.name; else loader" class="pl-12 pr-16 flex vertical-indicator items-center">{{'INSTANCE_DETAILS.INSTANCE' | transloco}}: <span class="fw-600 fs-14 pl-6">{{data.name}}</span></div>
        <div *ngIf="instanceVersion; else loader" class="pl-12 pr-16 flex items-center">{{'BLUEPRINT_SUMMARY.RELEASE' | transloco}}: <span class="fw-600 fs-14 pl-6">{{instanceVersion.releaseVersion ? instanceVersion.releaseVersion : '-'}}</span></div>
				<ng-template #loader>
				  <div class="pl-6 skeleton-loader pr-16">
					<ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
				  </div>
				</ng-template>
				<ng-template #headerLoader>
				  <div class="pl-6 skeleton-loader-header">
					<ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
				  </div>
				</ng-template>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
      <div *ngIf="!summaryPage" class="flex flex-row items-end mb-24">
      <div>
        <div class="flex flex-row mat-body-2 fw-700 fs-12">
            {{'INSTANCE_DETAILS.UPDATE_BUILD.RELEASE_VERSION' | transloco}}
            <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.UPDATE_BUILD.RELEASE_VERSION' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div class="mat-body fw-500 pt-8">
            <mat-select [ngClass]="{'disabled': selectedComponentsArray?.length > 0}" class="fw-500 form-select version-selections" placeholder="{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}" [value]="selectedVersion" panelClass="version-selections" (click)="resetFilter()" (selectionChange)="getSelectedVersion($event.value)">
              <div class="flex search-bar m-8">
                <span (click)="searchChanged(searchValue)" class="pt-4 w-26"><mat-icon class="mr-8 icon-sm icon-color ml-6 mt-4 mr-10" svgIcon="search"></mat-icon></span>
                <input class="fw-400 h-30 fs-14" [(ngModel)]="searchValue" (ngModelChange)="onOptionsSearched(searchValue)" placeholder="Search" type="text">                      
              </div>
              <mat-option *ngIf="versionData?.length === 0"> <div class="ml-16 mr-16 mt-8 mb-8 flex justify-center" *ngIf="versionData?.length === 0">{{'INSTANCE_DETAILS.UPDATE_BUILD.NO_VERSIONS_FOUND' | transloco}}</div></mat-option>
              <mat-option *ngFor="let version of versionData" [value]="version?.version" [title]="version?.version" [ngClass]="{'group-title': version.group, 'group-items': !version.group}">{{version?.version}}</mat-option>
            </mat-select>
        </div>
    </div>
    <div *ngIf="componentEnable" class="vertical-indicator-connector mr-24 ml-24"></div>
    <div *ngIf="componentEnable">
        <div class="flex flex-row mat-body-2 fw-700 fs-12">
            {{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco}}
            <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div *ngIf="showDropdown" class="mat-body fw-500 pt-8">
            <select class="fw-500 form-select-component" (change)='onComponentSelected($event.target.value)'>
                <option [ngValue]="null" [disabled]="true" hidden>{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}</option>
                <option *ngFor="let element of componentsArray">{{element}}</option>
            </select>
        </div>
    </div>
    <div *ngIf="componentEnable">
        <button
        class="flex justify-center items-center add-button primary-fg p-16 ml-24" type="button" [ngClass]="{'disabled': !addEnable}"
        (click)="add()">{{ 'BUTTONS.ADD' | transloco }}
      </button>
    </div>
    </div>
    <div *ngIf="summaryPage">
        <div class="flex flex-row mat-body-2 fw-700 fs-24 mb-32">
            {{'INSTANCE_DETAILS.UPDATE_BUILD.SUMMARY' | transloco}}
        </div>

        <div *ngIf="data.packageReferenceId" class="flex flex-row items-center mb-24">
            <mat-icon [svgIcon]="externalSelected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md" (click)="selectExternalTypes()"></mat-icon>
            <span class="pl-8 flex flex-row">{{'INSTANCE_DETAILS.UPDATE_BUILD.ADD_EXTERNAL_PACKAGE_COMPONENT_MESSAGE' | transloco}}</span>
            <span class="ml-24 underline orange cursor-pointer" (click)="customPackageView()">{{'SOLUTIONS.VIEW_CUSTOM_PACKAGES' | transloco }}</span>
          </div>
          <div class="flex flex-row mat-body-2 fw-700 fs-12">
            {{'INSTANCE_DETAILS.UPDATE_BUILD.RELEASE_VERSION' | transloco}}
            <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.UPDATE_BUILD.RELEASE_VERSION' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div class="version-selected flex items-center justify-start pl-12 mb-24">
                {{versionSelected}}
            </div>

    </div>
    <ng-container *ngIf="tableLoader">
      <div class="loader-section flex flex-col items-center justify-center">
        <mat-spinner class="flex items-center justify-center" diameter="36"
          color="primary"
          mode="indeterminate">
        </mat-spinner>
        <div>{{'INSTANCE_DETAILS.UPDATE_BUILD.LOADER_DESC' | transloco}}</div>
      </div>
    </ng-container>
    <div class="component-table class-table" *ngIf="tableRender && selectedComponentsArray?.length > 0">
        <table mat-table [dataSource]="selectedComponentsArray" class="w-100-percent">
            <ng-container matColumnDef="name">
            <th mat-header-cell class="fs-14" *matHeaderCellDef>{{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco}}</th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'dependent-name dependent': element.dependent}"> {{element.name}} </td>
            </ng-container>
            <ng-container matColumnDef="value">
            <th mat-header-cell class="fs-14" *matHeaderCellDef>{{'INSTANCE_DETAILS.CURRENT_VERSION' | transloco}}</th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'dependent': element.dependent}"> {{element.value}} </td>
            </ng-container>
            <ng-container matColumnDef="dependents">
            <th mat-header-cell class="fs-14" *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'dependent': element.dependent}">
                <span class="flex flex-row cursor-pointer red" *ngIf="element?.dependentsAvailable" (click)="dependentAddition()">
                    <mat-icon svgIcon="error" class="icon-sm mr-6 mt-4 red"></mat-icon>
                    <span>{{missingDependency?.length}} {{'INSTANCE_DETAILS.UPDATE_BUILD.DEPENDENTS_AVAILABLE' | transloco}}</span>
                </span>
                <span [ngClass]="{'disabled': failedClicked}" class="flex flex-row cursor-pointer red" *ngIf="element?.dependencyVerification" (click)="failed()">
                  <mat-icon svgIcon="error" class="icon-sm mr-6 mt-4 red"></mat-icon>
                  <span>{{'INSTANCE_DETAILS.UPDATE_BUILD.DEPENDENCY_FAILED' | transloco}}</span>
              </span>
            </td>
            </ng-container>
            <ng-container matColumnDef="addDependents">
                <th mat-header-cell class="fs-14" *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'dependent': element.dependent}">
                    <span class="cursor-pointer underline" *ngIf="element?.dependentsAvailable" (click)="addDependent()">
                        {{'INSTANCE_DETAILS.UPDATE_BUILD.ADD_DEPENDENT' | transloco }}
                    </span>
                </td>
                </ng-container>
            <ng-container matColumnDef="delete">
            <th mat-header-cell class="fs-14" *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'dependent': element.dependent}">
                <mat-icon *ngIf="!summaryPage && !element.dependent" svgIcon="delete" class="icon-md red cursor-pointer" (click)="delete(element)"></mat-icon>
            </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="datazoneColumns"></tr>
            <tr mat-row  *matRowDef="let row; columns: datazoneColumns;"></tr>
        </table>
    </div>
</div>
<span class="flex-auto"></span>
  <div class="flex flex-row summary-header mt-auto pr-72">
    <button class="flex justify-center items-center blend-border cancel-btn ml-auto mr-18 p-16 pl-42 pr-42" (click)="goToTenant()">
        <mat-icon svgIcon="close" class="icon-sm cursor-pointer mr-8"></mat-icon>
        {{ 'BUTTONS.CANCEL' | transloco }}
      </button>
      <button [ngClass]="{'disabled': !enableContinue}"
        class="flex justify-center items-center mossgreen primary-fg p-16 pl-42 pr-42" (click)="clickContinue()" type="button">{{ !summaryPage ? ('BUTTONS.CONTINUE' | transloco) : ('BUTTONS.SUBMIT' | transloco) }}
        <mat-icon svgIcon="arrow_forward" class="icon-sm ml-8"></mat-icon>
      </button>
    </div>
